import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type BannersSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_BANNERS_SORT_OPTION: BannersSortOption = "newest";

const OPTIONS: SortOption<BannersSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function bannersSortOptionLabel(option: BannersSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function bannersSortOptionToParams(option: BannersSortOption): {
  sortBy: "created_at" | "title";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "created_at", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "created_at", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "title", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "title", sortOrder: "DESC" };
  }
}

export default function SortBannersPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: BannersSortOption;
  setSortOption: (option: BannersSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Banners"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
